module.exports = __webpack_public_path__ + "img/Askoylogo2.c802c3f1.png";